export default "__VITE_ASSET__fd074071__"